import type {NavigationGuard, RouteLocationNormalized, Router} from 'vue-router'

import NotificationMessageService from "@/services/notificationmessage.service";
import {PermissionsService} from '@/services/permissions.service'

const guardFactory = function (router: Router, keycloak: any): NavigationGuard {
  return async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized
  ) => {
    const perm = new PermissionsService(keycloak);

    // If reload the permission token might not be loaded yet
    if (!keycloak?.permissions_token) {
      await keycloak?.fetchPermissionsToken()
    }

    switch (to.name) {
      // case "My Orders":
      //   if (perm.hasOrderReadPermission || perm.hasOrderReadAllPermission) {
      //     return true;
      //   }
      //   break;
      case "View Order":
        if (
          perm.hasOrderReadPermission ||
          perm.hasOrderReadAllPermission
        ) {
          return true;
        }
        break;
      case "Create Order":
        if (
          perm.hasOrderCreatePermission ||
          perm.hasOrderCreateAllPermission
        ) {
          return true;
        }
        break;
      case "Select New Order Template":
        if (
          perm.hasOrderCreatePermission ||
          perm.hasOrderCreateAllPermission
        ) {
          return true;
        }
        break;
      case "Edit Order":
        if (
          perm.hasOrderUpdatePermission ||
          perm.hasOrderUpdateAllPermission
        ) {
          return true;
        }
        break;
      // case "My Patients":
      //   if (
      //     perm.hasPatientReadPermission ||
      //     perm.hasPatientReadAllPermission
      //   ) {
      //     return true;
      //   }
      //   break;
      case "Create Patient":
        if (
          perm.hasPatientCreatePermission ||
          perm.hasPatientCreateAllPermission
        ) {
          return true;
        }
        break;
      case "Edit Patient":
        if (
          perm.hasPatientUpdatePermission ||
          perm.hasPatientUpdateAllPermission
        ) {
          return true;
        }
        break;
      default:
        return true;
    }

    NotificationMessageService.showWarning("Not Enough Permissions");

    return false;
  }
}

export default guardFactory
